window.app = window.app || {};

var bookingPaymentFormStyles = {
    'input': {
        'font-family': 'verdana, sans-serif',
        'color': '#646260',
        'display': 'block',
        'height': '15px',
        'padding': '0',
        'font-size': '11px',
        'line-height': '15px',
        'border': '1px solid #b8b8b8 !important'
    },
    'label': {
        'font-family': 'verdana, sans-serif',
        'color': '#666666',
        'font-size': '10px',
        'font-weight': '400'
    },
    ':disabled': {'cursor': 'not-allowed'},
};

(function($) {

    formHelper.addRule({
        form: '#step1Info',
        status: {
            SUCCESS: '/book/review_your_reservation'
        }
    });

    formHelper.addRule({
        form: '#form-complete-booking-cybersource',
        status: {
            SUCCESS: '/book/thank_you',
            BOOKING_ERROR: '/book/booking_error',
            SESSION_EXPIRED: '/book/session_expired',
            PAYMENT_INFO_EXPIRED: function() {
                this.$form.find('#flex-response').val('');
            },
            CAPTURE_CONTEXT_ERROR: '/book/booking_error',
            PERFORM_CYBERSOURCE_AUTH: function() {

                var config = {
                    ajaxURLs: {
                        performCyberSourceAuth:                '/h/book/AjaxPerformCyberSourceAuth',
                        storeCardinalJwtResponse:              '/h/book/AjaxStoreCardinalJwtResponse',
                        cyberSourcePayerAuthValidationRequest: '/h/book/AjaxCyberSourcePayerAuthValidationRequest'
                    }
                };

                window.app.perform3dsCybersourceAuth(this, config);
            },
            ERROR: function() {

                this.$form.find('#flex-response').val('');

                if (this.errors[0].code === 'new-capture-context') {

                    window.app.loadFlexMicroformScript(this.data.newCaptureContextData, bookingPaymentFormStyles);
                }
            }
        },
        xhrReady: function(xhrOptions) {

            var $form = this.$form;

            xhrOptions.data['cybersource-3ds-success-submit'] = $form.data('cybersource-3ds-success-submit');

            window.app.flexCreateToken(xhrOptions, this);
        }
    });

	formHelper.addIPeerRule({
		// ID of the Payment form on the WWW site
		// No need to call out the form id inside the iframe
		// The selector 'form' is always used
		form: '#form-complete-booking-vpos',
		status: {
			// SUCCESS is what we would do if BOTH the iframe cde
			// and the www forms are successful
            SUCCESS: '/book/thank_you',
            BOOKING_ERROR: '/book/booking_error',
            SESSION_EXPIRED: '/book/session_expired'
		}
	});

	formHelper.addRule({
		form: '#form-complete-booking-no-payment',
        status: {
            // SUCCESS is what we would do if BOTH the iframe cde
            // and the www forms are successful
            SUCCESS: '/book/thank_you',
            BOOKING_ERROR: '/book/booking_error',
            SESSION_EXPIRED: '/book/session_expired'
        },
		xhrReady: function(xhrOptions) {
			xhrOptions.data['peer-status'] = 'SUCCESS';
		}
	});

})(jQuery);

jQuery(function initCompleteBookingForm($) {

    $('#form-complete-booking-cybersource').each(function (index, el) {

        window.app.initializeMicroform();

        var captureContextData = JSON.parse(captureContextDataJSON);

        window.app.loadFlexMicroformScript(captureContextData, bookingPaymentFormStyles);

        var $form = $(this);

        $form.keydown(function (e) {
            if (e.key === 'Enter') {
                e.preventDefault();
            }
        });
    });
});


jQuery(function($){

	$(document).on('click','.fh-js-complete-booking-submitter',function(event){
        if (window.app.promoCodeFieldEmpty()) {
            event.preventDefault();
            $('#form-complete-booking-no-payment').submit();
        }
	});
});
